import React from 'react';

import { View } from '@uncinc/react-drupal-core';

interface ActivitiesOverviewBuurtboerderijProps {
  display: string;
}

// eslint-disable-next-line max-len
const ActivitiesOverviewBuurtboerderij: React.FC<ActivitiesOverviewBuurtboerderijProps> = ({ display }) => (
  <div className="ActivitiesOverviewBuurtboerderij">
    <View id="content_overview" display={display} />
  </div>
);

export default ActivitiesOverviewBuurtboerderij;
